(function () {
  angular.module("akitabox.ui.dialogs.job", [
    "akitabox.core.lib.moment",
    "akitabox.core.services.building",
    "akitabox.ui.dialogs.job.cancel",
    "akitabox.ui.dialogs.job.create",
    "akitabox.ui.dialogs.job.viewStepLog",
  ]);
})();
